import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import api from '../../api';
import Layout from '../../components/Layout';
import stili from '../../components/competenze/stili';
import { usePuoScrivere } from '../../utils/permessi';
import { quando } from './comuni';

// Cestino di Anagrafiche: aziende eliminate. Si vede con la lettura, si ripristina con la scrittura (singolo o in blocco).
// Il ripristino è rifiutato (409) se nel frattempo esiste un'altra azienda con lo stesso codice fiscale o partita IVA.
export default function CestinoAnagrafiche() {
  const puoScrivere = usePuoScrivere('anagrafiche');
  const [righe, setRighe] = useState([]);
  const [selezionate, setSelezionate] = useState([]);
  const [esito, setEsito] = useState(null);
  const [errore, setErrore] = useState('');
  const [inCorso, setInCorso] = useState(false);

  const carica = useCallback(async () => {
    try {
      const res = await api.get('/anagrafiche/cestino');
      setRighe(res.data.aziende);
      setSelezionate(sel => sel.filter(id => res.data.aziende.some(a => a.id === id)));
    } catch (err) { setErrore(err.response?.data?.errore || 'Errore nel caricamento'); }
  }, []);
  useEffect(() => { carica(); }, [carica]);

  const ripristina = async (ids) => {
    if (inCorso || !ids.length) return;
    setErrore('');
    setInCorso(true);
    try {
      const res = await api.post('/anagrafiche/cestino/ripristina', { ids });
      setEsito(res.data);
    } catch (err) {
      const non = err.response?.data?.non_ripristinate;
      if (non) setEsito({ ripristinate: 0, non_ripristinate: non });
      else setErrore(err.response?.data?.errore || 'Ripristino non riuscito');
    } finally {
      window.dispatchEvent(new Event('cestino-aggiornato'));
      setInCorso(false);
      setSelezionate([]);
      carica();
    }
  };
  const tutte = righe.length > 0 && selezionate.length === righe.length;

  return (
    <Layout>
      <div style={stili.topBar}><h2 style={{ margin: 0 }}>Cestino di Anagrafiche</h2></div>
      <p style={{ color: '#555', fontSize: '0.88rem', marginTop: 0 }}>Aziende eliminate. {puoScrivere ? 'Ripristinale una alla volta o in blocco.' : 'Per ripristinarle serve il permesso di scrittura.'}</p>
      {errore && <div style={stili.errore}>{errore}</div>}

      {puoScrivere && selezionate.length > 0 && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', background: '#232323', color: 'white', padding: '0.6rem 0.9rem', borderRadius: '8px', marginBottom: '0.8rem', flexWrap: 'wrap' }}>
          <strong>{selezionate.length} selezionate</strong>
          <button onClick={() => ripristina(selezionate)} disabled={inCorso} style={{ ...stili.btn, background: '#D3D678', color: '#232323', fontWeight: 600 }}>{inCorso ? 'Ripristino…' : 'Ripristina selezionate'}</button>
          <button onClick={() => setSelezionate([])} style={stili.btnSmall}>Annulla selezione</button>
        </div>
      )}

      {esito && (
        <div role="status" style={{ border: `1px solid ${esito.non_ripristinate.length ? '#fdba74' : '#86efac'}`, background: esito.non_ripristinate.length ? '#fff7ed' : '#ecfdf5', borderRadius: '8px', padding: '0.7rem 0.9rem', marginBottom: '0.8rem', fontSize: '0.88rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem' }}>
            <strong>{esito.ripristinate} {esito.ripristinate === 1 ? 'ripristinata' : 'ripristinate'}{esito.non_ripristinate.length ? `, ${esito.non_ripristinate.length} non ripristinate` : ''}</strong>
            <button onClick={() => setEsito(null)} style={stili.btnSmall}>Chiudi</button>
          </div>
          {esito.non_ripristinate.length > 0 && (
            <ul style={{ margin: '0.4rem 0 0', paddingLeft: '1.2rem', color: '#9a3412' }}>
              {esito.non_ripristinate.map(x => <li key={x.id}><strong>{x.riferimento}</strong>: {x.motivo}</li>)}
            </ul>
          )}
        </div>
      )}

      <div style={{ overflowX: 'auto' }}>
        <table style={stili.table}>
          <thead>
            <tr>
              {puoScrivere && <th style={{ ...stili.th, width: '2.2rem' }}><input type="checkbox" aria-label="Seleziona tutte" checked={tutte} onChange={e => setSelezionate(e.target.checked ? righe.map(a => a.id) : [])} /></th>}
              {['Ragione sociale', 'Codice fiscale', 'Partita IVA', 'Eliminata il', 'Eliminata da'].map(t => <th key={t} style={stili.th}>{t}</th>)}
              {puoScrivere && <th style={stili.th} />}
            </tr>
          </thead>
          <tbody>
            {righe.map(a => (
              <tr key={a.id} style={{ ...stili.tr, ...(selezionate.includes(a.id) ? { background: '#F7F7EA' } : {}) }}>
                {puoScrivere && <td style={stili.td}><input type="checkbox" aria-label={`Seleziona azienda ${a.id}`} checked={selezionate.includes(a.id)} onChange={e => setSelezionate(s => (e.target.checked ? [...s, a.id] : s.filter(x => x !== a.id)))} /></td>}
                <td style={stili.td}>{a.ragione_sociale}</td>
                <td style={{ ...stili.td, whiteSpace: 'nowrap' }}>{a.codice_fiscale || <span style={{ color: '#bbb' }}>—</span>}</td>
                <td style={{ ...stili.td, whiteSpace: 'nowrap' }}>{a.partita_iva || <span style={{ color: '#bbb' }}>—</span>}</td>
                <td style={{ ...stili.td, whiteSpace: 'nowrap' }}>{quando(a.eliminato_il)}</td>
                <td style={stili.td}>{a.eliminato_da_nome}</td>
                {puoScrivere && <td style={stili.td}><button onClick={() => ripristina([a.id])} disabled={inCorso} style={stili.btnSmall}>Ripristina</button></td>}
              </tr>
            ))}
            {righe.length === 0 && <tr><td colSpan={puoScrivere ? 7 : 5} style={{ ...stili.td, textAlign: 'center', color: '#999', padding: '1.5rem' }}>Il Cestino è vuoto</td></tr>}
          </tbody>
        </table>
      </div>
      <p style={{ marginTop: '1rem', fontSize: '0.86rem' }}><Link to="/anagrafiche">← Torna alle anagrafiche</Link></p>
    </Layout>
  );
}
